import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';
Vue.use(Vuetify);

export default new Vuetify({
    theme: {
      themes: {
        light: {
          defaultColor: '#102A62',
          defaultColorLight: '#004F9F',
          defaultColorLightTwo: '#007AFF',
          defaultColorLightThree: '#D3DAE9',
          redColor: '#B60711',
          greyColor: '#C6CCD2',
          greyColorLigth: '#DFDFE2',
          greyColorLigthTwo: '#F6F3F0',
          greyColorLigthThree: '#FAF7F4',
          greyColorLigthFour: '#E7E6E6',
          greyColorDark: '#838EA9',
          greenColor: '#50AF47',
        },
        dark: {
          
        },
      },
    },
  });
